export default __webpack_public_path__ + "static/media/clever-icon.4df19838.png";